/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Icon, Option, Select, Text } from '@tonic-one/react';
import { DeleteIcon, EditIcon } from '@tonic-one/react-icons';
import {
  usePolicyContext,
  storeSelector,
  templateSelector,
} from '@Policy/store';
import { DlpPolicyItem, TableColumn } from '@Policy/utils/types';
import isEqual from 'lodash/isEqual';
import { slfExceptionListSelector } from '@Policy/store/filters/shareLink';
import SmartTooltip from '@Report/SmartTooltip';

export const useSlfExceptionListColumns = (
  handleEditClick: (index: number) => void,
  handleDeleteClick: (index: number) => void
) => {
  const { t } = useTranslation();
  // local state
  const slfExceptionListColumns = React.useMemo(() => {
    const columns: TableColumn[] = [
      {
        id: 'exceptionUsers',
        header: t('policy.shareLink.header.usersGroups'),
        size: 206,
        style: {
          lineHeight: '30px',
        },
        cell: (row: any) => {
          const { slfExceptionUsers } = row.row;
          return (
            <Flex direction="column">
              {slfExceptionUsers.map((target: string) => (
                <Text key={target}>{target}</Text>
              ))}
            </Flex>
          );
        },
      },
      {
        id: 'exceptionPaths',
        header: t('policy.shareLink.header.paths'),
        cell: (row: any) => {
          const { slfExceptionPaths } = row.row;
          return (
            <Flex direction="column">
              {slfExceptionPaths.map((path: string) => (
                <SmartTooltip>{path}</SmartTooltip>
              ))}
            </Flex>
          );
        },
        size: 268,
      },
      {
        id: 'action',
        header: t('policy.action'),
        cell: (row: any) => {
          return (
            <>
              <Icon
                as={DeleteIcon}
                ml="8px"
                onClick={() => {
                  handleDeleteClick(row.id);
                }}
              />
              <Icon
                as={EditIcon}
                ml="8px"
                onClick={() => {
                  handleEditClick(row.id);
                }}
              />
            </>
          );
        },
        size: 268,
      },
    ];
    return columns;
  }, []);
  return {
    slfExceptionListColumns,
  };
};

export const useSlfExceptionListRows = (
  slfExceptionListColumns: TableColumn[]
) => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state from store
  const slfExceptionList = contextSelector(slfExceptionListSelector, isEqual);
  // get action from store

  const slfExceptionListRows = React.useMemo(() => {
    const result = slfExceptionList.map((row, rowIndex) => {
      return {
        id: `${rowIndex}`,
        cells: slfExceptionListColumns.map(
          (column: TableColumn, columnIndex: number) => {
            return {
              id: `${columnIndex}_${column.id}`,
              column,
              row,
            };
          }
        ),
        row,
      };
    });
    return result;
  }, [slfExceptionListColumns, slfExceptionList]);
  return {
    slfExceptionListRows,
  };
};
